"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropped = exports.claimed = exports.unmatched = void 0;
exports.unmatched = { matched: false };
const claimed = (value) => ({
    matched: true,
    value,
});
exports.claimed = claimed;
exports.dropped = { matched: true, value: null };
